module.exports = __webpack_public_path__ + "img/8.da4fc190.png";